import React, { useEffect, useMemo, useState } from "react";

import CarFilter from "./components/CarFilter/CarFilter";
import CarList from "./CarList/CarList";

import styles from "./CarsPage.module.css";
import { useSelector } from "react-redux";
import { selectCars } from "../redux/car/car-slice";
import { parseLocalizedNumber, toEnglishDigits } from "../services/functions";

const CarsPage = () => {
    const cars = useSelector(selectCars);

    const [activeFilters, setActiveFilters] = useState({
        search: "",
        manufacturer: "",
        productYear: "",
    });

    const filteredCars = useMemo(() => {
    const search =
        activeFilters.search
            .trim()
            .toLowerCase();

    const manufacturer =
        activeFilters.manufacturer
            .trim()
            .toLowerCase();

    const productYear =
        activeFilters.productYear
            .trim();

    return cars.filter((car) => {
        const title =
            String(car?.title || "")
                .toLowerCase();

        const carManufacturer =
            String(
                car?.company || ""
            ).toLowerCase();

        const year =
            String(
                toEnglishDigits(car?.productYear) || ""
            );

        const matchesSearch =
            !search ||
            title.includes(search);

        const matchesManufacturer =
            !manufacturer ||
            carManufacturer === manufacturer;

        const matchesYear =
            !productYear ||
            year === productYear;

        return (
            matchesSearch &&
            matchesManufacturer &&
            matchesYear
        );
    });
}, [cars, activeFilters]);
    // const filteredCars = useMemo(() => {
    //     const search =
    //         activeFilters.search
    //             .trim()
    //             .toLowerCase();

    //     const manufacturer =
    //         activeFilters.manufacturer
    //             .trim()
    //             .toLowerCase();

    //     const productYear =
    //         activeFilters.productYear
    //             .trim();

    //     return cars.filter((car) => {
    //         const title =
    //             String(car?.title || "")
    //                 .toLowerCase();

    //         const carManufacturer =
    //             String(
    //                 car?.manufacturer || ""
    //             ).toLowerCase();

    //         const year =
    //             String(
    //                 car?.productYear || ""
    //             );

    //         const matchesSearch =
    //             !search ||
    //             title.includes(search);

    //         const matchesManufacturer =
    //             !manufacturer ||
    //             carManufacturer.includes(
    //                 manufacturer
    //             );

    //         const matchesYear =
    //             !productYear ||
    //             year === productYear;

    //         return (
    //             matchesSearch &&
    //             matchesManufacturer &&
    //             matchesYear
    //         );
    //     });
    // }, [cars, activeFilters]);

    const handleApplyFilter = (filters) => {
        setActiveFilters(filters);
    };

    const handleCancelFilter = () => {
        setActiveFilters({
            search: "",
            manufacturer: "",
            productYear: "",
        });
    };

    return (
        <main
            className={styles.page}
            dir="rtl"
        >
            <header className={styles.header}>
                <h1>همه خودروها</h1>

                <p>
                    مدیریت و مشاهده اطلاعات خودروها
                </p>
            </header>

            <CarFilter
                onApply={handleApplyFilter}
                onCancel={handleCancelFilter}
                resultCount={filteredCars.length}
            />

            <CarList
                cars={filteredCars}
            />
        </main>
    );
};

export default CarsPage;